module.exports = __webpack_public_path__ + "static/media/assembly_S2.1e9777bf.png";